import {
  InspectionType,
  useInspection
} from '@/services/providers/InspectionContext'

const inspectionTypeToUIMapper = {
  BR: {
    '5asec': '5àsec',
    acompanhamentoObraMM: 'Medição de Obra - MM',
    aditivo: 'Vistoria de Aditivo',
    auditoriaLoja: 'Auditoria de Loja',
    avaliacao: 'Vistoria de Avaliação',
    avaliacaoHousi: 'Visita Técnica Housi',
    cashme: 'CashMe',
    cautelar: 'Cautelar',
    cautelarAterpa: 'Cautelar - ATERPA',
    cautelarQueirozGalvao: 'Cautelar - ENGETEC',
    cautelarCCInfra: 'Cautelar - CCInfra',
    checklistSamsung: 'Vistoria de Auditoria Samsung',
    conferencia: 'Vistoria de Conferência',
    conferenciaFinalDeObra: 'Conferência de Final de Obra',
    entrada: 'Vistoria de Entrada',
    entradaBHomy: 'Vistoria de Entrada B.Homy',
    entradaLight: 'Vistoria de Entrada Lite',
    entrega: 'Vistoria de Entrega',
    finalDeObra: 'Vistoria de Final de Obra',
    inspecaoPredial: 'Vistoria de Inspeção Predial',
    inventario: 'Vistoria de Inventário',
    orcamento: 'Vistoria de Orçamento',
    predial: 'Predial',
    predialO2: 'Predial O2',
    preVistoriaBHomy: 'Pré-Vistoria B.Homy',
    saida: 'Vistoria de Saída',
    tombamento: 'Vistoria de Tombamento',
    transferencia: 'Vistoria de Transferência',
    vialaser: 'Vialaser',
    visita: 'Visita',
    entradaCurtaTemporada: 'Entrada Curta Temporada',
    saidaCurtaTemporada: 'Saída Curta Temporada'
  },
  PT: {
    '5asec': '5àsec',
    acompanhamentoObraMM: 'Medição de Obra - MM',
    aditivo: 'Vistoria de Aditivo',
    auditoriaLoja: 'Auditoria de Loja',
    avaliacao: 'Vistoria de Avaliação',
    avaliacaoHousi: 'Visita Técnica Housi',
    cashme: 'CashMe',
    cautelar: 'Cautelar',
    cautelarAterpa: 'Cautelar - ATERPA',
    cautelarQueirozGalvao: 'Cautelar - ENGETEC',
    cautelarCCInfra: 'Cautelar - CCInfra',
    checklistSamsung: 'Vistoria de Auditoria Samsung',
    conferencia: 'Vistoria de Conferência',
    conferenciaFinalDeObra: 'Conferência de Final de Obra',
    entrada: 'Vistoria de Entrada',
    entradaBHomy: 'Vistoria de Entrada B.Homy',
    entradaLight: 'Vistoria de Entrada Lite',
    entrega: 'Vistoria de Entrega',
    finalDeObra: 'Vistoria de Final de Obra',
    inspecaoPredial: 'Vistoria Predial',
    inventario: 'Vistoria de Inventário',
    orcamento: 'Vistoria de Orçamento',
    predial: 'Predial',
    predialO2: 'Predial O2',
    preVistoriaBHomy: 'Pré-Vistoria B.Homy',
    saida: 'Vistoria de Final de Contrato',
    tombamento: 'Vistoria de Tombamento',
    transferencia: 'Vistoria de Compra/Venda',
    vialaser: 'Vialaser',
    visita: 'Visita',
    entradaCurtaTemporada: 'Entrada Curta Temporada',
    saidaCurtaTemporada: 'Saída Curta Temporada'
  },
  ES: {
    '5asec': '5àsec',
    acompanhamentoObraMM: 'Medición de Obra - MM',
    aditivo: 'Inspección de Anexo',
    auditoriaLoja: 'Auditoría de Local',
    avaliacao: 'Inspección de Valoración',
    avaliacaoHousi: 'Visita Técnica Housi',
    cashme: 'CashMe',
    cautelar: 'Cautelar',
    cautelarAterpa: 'Cautelar - ATERPA',
    cautelarQueirozGalvao: 'Cautelar - ENGETEC',
    cautelarCCInfra: 'Cautelar - CCInfra',
    checklistSamsung: 'Inspección de Auditoría Samsung',
    conferencia: 'Inspección de Comprobación',
    conferenciaFinalDeObra: 'Comprobación de Final de Obra',
    entrada: 'Inspección de Entrada',
    entradaBHomy: 'Inspección de Entrada B.Homy',
    entradaLight: 'Inspección de Entrada Lite',
    entrega: 'Inspección de Entrega',
    finalDeObra: 'Inspección de Final de Obra',
    inspecaoPredial: 'Inspección del Edificio',
    inventario: 'Inspección de Inventario',
    orcamento: 'Inspección de Presupuesto',
    predial: 'Edificio',
    predialO2: 'Edificio O2',
    preVistoriaBHomy: 'Pre-Inspección B.Homy',
    saida: 'Inspección de Salida',
    tombamento: 'Inspección de Catalogación',
    transferencia: 'Inspección de Compraventa',
    vialaser: 'Vialaser',
    visita: 'Visita',
    entradaCurtaTemporada: 'Entrada Corta Temporada',
    saidaCurtaTemporada: 'Salida Corta Temporada'
  },
  UY: {
    '5asec': '5àsec',
    acompanhamentoObraMM: 'Medición de Obra - MM',
    aditivo: 'Inspección de Aditivo',
    auditoriaLoja: 'Auditoría de Local',
    avaliacao: 'Inspección de Evaluación',
    avaliacaoHousi: 'Visita Técnica Housi',
    cashme: 'CashMe',
    cautelar: 'Cautelar',
    cautelarAterpa: 'Cautelar - ATERPA',
    cautelarQueirozGalvao: 'Cautelar - ENGETEC',
    cautelarCCInfra: 'Cautelar - CCInfra',
    checklistSamsung: 'Inspección de Auditoría Samsung',
    conferencia: 'Inspección de Conferencia',
    conferenciaFinalDeObra: 'Conferencia de Final de Obra',
    entrada: 'Inspección de Entrada',
    entradaBHomy: 'Inspección de Entrada B.Homy',
    entradaLight: 'Inspección de Entrada Lite',
    entrega: 'Inspección de Entrega',
    finalDeObra: 'Inspección de Final de Obra',
    inspecaoPredial: 'Inspección Predial',
    inventario: 'Inspección de Inventario',
    orcamento: 'Inspección de Presupuesto',
    predial: 'Predial',
    predialO2: 'Predial O2',
    preVistoriaBHomy: 'Pre-Inspección B.Homy',
    saida: 'Inspección de Salida',
    tombamento: 'Inspección de Registro',
    transferencia: 'Inspección de Transferencia',
    vialaser: 'Vialaser',
    visita: 'Visita',
    entradaCurtaTemporada: 'Entrada Corta Temporada',
    saidaCurtaTemporada: 'Salida Corta Temporada'
  },
  PY: {
    '5asec': '5àsec',
    acompanhamentoObraMM: 'Medición de Obra - MM',
    aditivo: 'Inspección de Aditivo',
    auditoriaLoja: 'Auditoría de Local',
    avaliacao: 'Inspección de Evaluación',
    avaliacaoHousi: 'Visita Técnica Housi',
    cashme: 'CashMe',
    cautelar: 'Cautelar',
    cautelarAterpa: 'Cautelar - ATERPA',
    cautelarQueirozGalvao: 'Cautelar - ENGETEC',
    cautelarCCInfra: 'Cautelar - CCInfra',
    checklistSamsung: 'Inspección de Auditoría Samsung',
    conferencia: 'Inspección de Conferencia',
    conferenciaFinalDeObra: 'Conferencia de Final de Obra',
    entrada: 'Inspección de Entrada',
    entradaBHomy: 'Inspección de Entrada B.Homy',
    entradaLight: 'Inspección de Entrada Lite',
    entrega: 'Inspección de Entrega',
    finalDeObra: 'Inspección de Final de Obra',
    inspecaoPredial: 'Inspección Predial',
    inventario: 'Inspección de Inventario',
    orcamento: 'Inspección de Presupuesto',
    predial: 'Predial',
    predialO2: 'Predial O2',
    preVistoriaBHomy: 'Pre-Inspección B.Homy',
    saida: 'Inspección de Salida',
    tombamento: 'Inspección de Registro',
    transferencia: 'Inspección de Transferencia',
    vialaser: 'Vialaser',
    visita: 'Visita',
    entradaCurtaTemporada: 'Entrada Corta Temporada',
    saidaCurtaTemporada: 'Salida Corta Temporada'
  }
}

export const inspectionTypeToUI = (type: InspectionType) => {
  const { inspection } = useInspection()

  return inspectionTypeToUIMapper?.[inspection?.country || 'BR']?.[type] || ''
}
